import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Button, NativeSelect, Paper, Checkbox } from "@material-ui/core";
import api from "../../../../services/api";
import { useParams } from "react-router-dom";
import "../../TargetReport/TableContent/index.css";
import { useMessageBox } from "../../../../context/MessageBox";
import excelIcon from "../../../../assets/images/excel48.png";
import { TOKEN_USER } from '../../../../services/auth';
import { toast } from "react-toastify";
import * as S from './formStyle';
import { capitalizeFirstLetter } from '../../../../utils/functions';
import AnchorsLogoOptions from './AnchorsLogoOptions'

function OperationsMiddle({
  setTableData,
  setProjecaoTableData,
  setProjecaoTotalTableData,
  setHeaderData,
  setTotalTableData,
  updateMetaData,
  setIsLoading,
  isLoading,
  anchors,
  handleSelectAnchor,
  selectedAnchor,
  triggerUpdateAnchor,
  setTriggerUpdateAnchor
}) {
  const getInitialDate = () => {
    const initialDate = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.proximoDiaUtil;
    return initialDate ? new Date(initialDate) : new Date();
  }
  const classes = S.useStyles();
  const [mainDate, setMainDate] = useState(getInitialDate);
  const [triggerUpdate, setTriggerUpdate] = useState(true);
  const [report, setReport] = useState();
  const [destinoPagamento, setDestinoPagamento] = useState("0");
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const [increase, setIncrease] = useState(0);
  const [mostrarIgnorados, setMostrarIgnorados] = useState('Todos')
  const [corporate, setCorporate] = useState('Todos')
  const screenParams = {
    title: "Relatório Metas",
    apiTable: "Relatorios/Relatorio005ProducaoDiaria",
    apiDownload: "Relatorios/Relatorio005ProducaoDiariaDownloadExcel",
    // apiDownloadExcel: 'Relatorios/Relatorio005ProducaoDiariaDownloadExcel',
    apiDownloadExcel: "Relatorios/Relatorio001ProducaoDariaDownloadExcel",
    dateFormat: "dd/MM/yyyy",
  };

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (mainDate && (triggerUpdate || triggerUpdateAnchor) && destinoPagamento && selectedAnchor) {
      await getInfoForForm();
    }
  }, [mainDate, destinoPagamento, selectedAnchor, mostrarIgnorados, corporate]);

  useEffect(() => {
    const initialize = async () => {
      await fetchDestinoPagamentos();
    };
    initialize();
  }, []);

  const fetchDestinoPagamentos = async () => {
    setIsLoading(true);
    try {
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')
      if (destinos && destinos.data && destinos.data.status == 'Sucesso') {
        setDestinoOpcoes(destinos.data.resposta)
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  const getInfoForForm = async () => {
    const dataIso = new Date(mainDate).toISOString()
    const dateArray = dataIso.split('T')
    const model = {
      dataPagamento: dateArray[0],
      incremento: increase,
      destinoPagamentoId: Number(destinoPagamento),
      ancoraId: selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0,
      plataformaId: selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0,
      filtroMostrarIgnorados: mostrarIgnorados,
      filtroPersonalizado: corporate,
    };
    setReport(model);
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      // Resetar a data do calendaraio sem atualizar o relatório
      if (relatorio?.data?.resposta?.dataPagamento) {
        setTriggerUpdate(false);
        setTriggerUpdateAnchor(false);
        setMainDate(new Date(relatorio?.data?.resposta?.dataPagamento));
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setHeaderData(relatorio.data.resposta);
        setTableData(relatorio.data.resposta.itens);
        setTotalTableData(relatorio.data.resposta.totalizador);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async (pdf) => {
    if (!report || pdf) return;
    setIsLoading(true);

    try {
      const url = pdf
        ? screenParams.apiDownload
        : screenParams.apiDownloadExcel;
      const relatorio = await api.post(url, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement("a");
      a.href =
        "data:" +
        relatorio.data.resposta.contentType +
        ";base64," +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          className='new-body-schedule'
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "20px",
            alignItems: 'center'
          }}>
          <div style={{ minWidth: '20%' }}>
            <AnchorsLogoOptions
              anchors={anchors}
              handleSelectAnchor={handleSelectAnchor}
              selectedAnchor={selectedAnchor}
            />
          </div>
          
          <div className='schedule-input'
            style={{ display: "flex", margin: "8px", alignItems: 'center', flexDirection: 'column' }}
          >
            <span className={classes.label}>Data de Pagamento: </span>
            <div style={{ display: "flex", alignItems: 'center' }}>
              <Button
                style={{
                  minWidth: "20px",
                  width: "20px",
                  height: "23px",
                  paddingLeft: "20px",
                }}
                onClick={() => {
                  setIncrease(-1);
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setDate(newDate.getDate() - 1));
                  setTriggerUpdate(true);
                }}>
                🢀
              </Button>

              <div
                style={{
                  padding: "0px 5px",
                  maxWidth: "150px",
                  height: "23px",
                }}>
                <DatePicker
                  selected={mainDate}
                  onChange={(date) => {
                    setIncrease(0);
                    setMainDate(date);
                    setTriggerUpdate(true);
                  }}
                  dateFormat={screenParams.dateFormat}
                  locale='ptBR'
                />
              </div>

              <Button
                style={{ minWidth: "20px", width: "20px", height: "23px" }}
                onClick={() => {
                  setIncrease(+1);
                  const newDate = new Date(mainDate);
                  setMainDate(newDate.setDate(newDate.getDate() + 1));
                  setTriggerUpdate(true);
                }}>
                🢂
            </Button>
            </div>
          </div>

          <div>
            <label className={classes.label}>Destino de Pagamentos</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setDestinoPagamento(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={destinoPagamento}
              >
                <option value="0">Consolidado</option>
                {destinoOpcoes.map((destino) => (
                  <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId}>
                    {capitalizeFirstLetter(destino.destinoPagamento)}
                  </option>
                ))}
              </NativeSelect>
            </Paper>
          </div>

          <div>
            <label className={classes.label}>Mostrar Ignorados</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="destinoPagamentos"
                className={classes.input}
                onChange={(e) => {
                  setMostrarIgnorados(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={mostrarIgnorados}
              >
                <option value="Todos">Todos</option>
                <option value="Ignorados">Ignorados</option>
                <option value="NaoIgnorados">Não Ignorados</option>
              </NativeSelect>
            </Paper>
          </div>
          <div>
            <label className={classes.label}>Personalizado</label>
            <Paper className={classes.medium} elevation={0}>
              <NativeSelect
                name="corporate"
                className={classes.input}
                onChange={(e) => {
                  setCorporate(e.target.value)
                  setTriggerUpdate(true);
                }}
                value={corporate}
              >
              <option value="Todos">Todos</option>       
              <option value="Corporate">Corporate</option>
              <option value="NaoCorporate">Não Corporate</option>
              <option value="Comissionado">Comissionado</option>
              <option value="NaoComissionado">Não Comissionado</option>
              <option value="CorporateComissionado">Corporate Comissionado</option>
              <option value="CorporateNaoComissionado">Corporate Não Comissionado</option>
              </NativeSelect>
            </Paper>
          </div>

          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable(false);
              }}
              style={{ cursor: "pointer", marginRight: "8px" }}></img>
            {/* <img src={pdfIcon} onClick={() => { exportTable(true) }} style={{ cursor: 'default', marginBottom: '4px' }} width="40"></img> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
